module.exports = __webpack_public_path__ + "media/images/vectorsol3-8d4dd47653dff0a96329ea3f9e22cad0.png";